import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { fontColors, OpacityStyleEnum } from '@sphereon/ui-components.core';
import { getIcon } from '../../../utils';
import { IconButtonContainerStyled as Container, SSITextH3Styled as Caption } from '../../../styles';
const IconButton = (props) => {
    const { caption, icon, iconColor = fontColors.dark } = props;
    const disabled = typeof props.disabled === 'function' ? props.disabled() : props.disabled ?? false;
    const onClick = async (event) => {
        if (!disabled) {
            props.onClick(event);
        }
    };
    return (_jsxs(Container, { style: {
            ...(disabled && { opacity: OpacityStyleEnum.DISABLED }),
        }, onClick: onClick, children: [getIcon(icon, iconColor), caption && _jsx(Caption, { children: caption })] }));
};
export default IconButton;
